import * as React from "react";
import {connect} from "react-redux";
import * as H from "history";
import BulkCreateSiteForm from "../../../models/BulkCreateSiteForm";
import ApiService from "../../ApiService";
import DispatchProps from "../../../utils/DispatchProps";
import { Fragment } from "react";
import {IRootState} from "../../../store";
import {MessageBarType, PrimaryButton} from "office-ui-fabric-react";
import Actions from "../../../redux/Actions";
import BulkSiteCreator from "../../BulkSiteCreator";
import {GroundFloorDurableFunctionInstance} from "../../../models/DurableFunctionInstance";
import GroundFloorDurableFunctionInstanceList from "../../GroundFloorDurableFunctionInstanceList";
import {buildIndexedSchools} from "../../../utils/IndexedSchools";
import School from "../../../models/School";
import {MegaMenuOptions} from "../../MegaMenuItemSelector";
import SchoolPageTitle from "../../SchoolPageTitle";
import AdminSchoolMenu from "../../AdminSchoolMenu";

interface AdminBulkSiteCreationPageProps
{
    tenantId: string;
    schoolCode: string;
    
    bulkSiteFormId?: string;
    
    history: H.History;
    apiService: ApiService;
}

interface AdminBulkSiteCreationPageState
{
    school?: School;
    megaMenuOptions?: MegaMenuOptions;

    bulkSiteForm?: BulkCreateSiteForm;
    workloadInstances: GroundFloorDurableFunctionInstance[];
    approveDisabled: boolean;
}

class AdminBulkSiteCreationPage extends React.Component<AdminBulkSiteCreationPageProps & DispatchProps,AdminBulkSiteCreationPageState>
{
    constructor(props: AdminBulkSiteCreationPageProps & DispatchProps) {
        super(props);
        this.state = {
            school: undefined,
            megaMenuOptions: undefined,
            
            bulkSiteForm: undefined,
            workloadInstances: [],
            approveDisabled: false,
        };
    }

    
    public async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
            const megaMenuOptions = await this.props.apiService.getMegaMenuOptions(this.props.tenantId,this.props.schoolCode);
            this.setState({
                school: school,
                megaMenuOptions: megaMenuOptions
            });
        }

        if (this.props.bulkSiteFormId)
        {
            const bulkSiteForm = await this.props.apiService.getBulkCreateSiteForm(this.props.bulkSiteFormId);
            this.setState({
                bulkSiteForm
            });
        }
        else
        {
            this.setState({
                bulkSiteForm: {
                    tenantId: this.props.tenantId,
                    schoolCode: this.props.schoolCode,
                    locked: false,
                    forms: [],
                }
            });
        }
    }
    
    async componentDidUpdate(prevProps: Readonly<AdminBulkSiteCreationPageProps & DispatchProps>, prevState: Readonly<AdminBulkSiteCreationPageState>, snapshot?: any): Promise<void>
    {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
            const megaMenuOptions = await this.props.apiService.getMegaMenuOptions(this.props.tenantId,this.props.schoolCode);

            this.setState({
                school: school,
                megaMenuOptions: megaMenuOptions
            });        
        }

        if (this.props.bulkSiteFormId && this.props.bulkSiteFormId !== prevProps.bulkSiteFormId) {
            const bulkSiteForm = await this.props.apiService.getBulkCreateSiteForm(this.props.bulkSiteFormId);

            this.setState({
                bulkSiteForm,
                workloadInstances: [],
                approveDisabled: false
            });
            
            await this.updateWorkloadsForForm();
        }
    }

    private async updateWorkloadsForForm()
    {
        if (this.props.bulkSiteFormId)
        {
            const workloadInstances = await this.props.apiService.getWorkloadInstancesForBulkSiteForm(this.props.bulkSiteFormId);
            this.setState({
                workloadInstances
            });
        }
    }

    private buildApproveButton() : JSX.Element | null
    {
        if(!this.props.bulkSiteFormId || !this.state.bulkSiteForm)
        {
            return null;
        }
        
        return (
            <PrimaryButton
                style={{display: this.state.bulkSiteForm?.locked ? "none" : "inherit"}}
                className={"m-left-auto"}
                disabled={this.state.approveDisabled}
                onClick={async () => {

                    this.setState({
                        approveDisabled: true
                    });

                    try
                    {
                        const updatedForm = await this.props.apiService.approveBulkCreateSiteForm(this.props.bulkSiteFormId!);
                        this.setState({
                            bulkSiteForm: updatedForm
                        });
                        this.props.dispatch(Actions.showMessageBar("Approved",MessageBarType.success));
                        await this.updateWorkloadsForForm();
                    }
                    catch(e)
                    {
                        console.log(e);
                        this.props.dispatch(Actions.showMessageBar(`Approval failed : ${e.message}`,MessageBarType.error));
                        this.setState({
                            approveDisabled: false
                        });
                    }
                }}
            >
                Approve and start workloads
            </PrimaryButton>
        );
    }
    
    private buildSaveChangesButton() : JSX.Element | null
    {
        if(!this.state.bulkSiteForm)
        {
            return null;
        }
        
        return (
            <PrimaryButton
                className={"m-left-auto"}
                disabled={this.state.bulkSiteForm.locked ? true : false}
                style={{display: this.state.bulkSiteForm.forms.length === 0 ? "none" : "inherit"}} onClick={async () => {
                try
                {
                    const updatedForm = await this.props.apiService.putBulkCreateSiteForm(this.state.bulkSiteForm!);
                    this.setState({
                        bulkSiteForm: updatedForm
                    });
                    await this.props.dispatch(Actions.showMessageBar(`Changes saved. (Form id ${updatedForm.id})`, MessageBarType.success));
                    if(!this.props.bulkSiteFormId)
                    {
                        this.props.history.replace(`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/bulk-site-forms/${updatedForm.id}`);
                    }
                }
                catch(e)
                {
                    await this.props.dispatch(Actions.showMessageBar(`Failed to save : ${e.message}`, MessageBarType.error));
                }

            }}>
                Save changes
            </PrimaryButton>
        );
    }
    

    public render() {

        if(!this.state.bulkSiteForm || this.state.school === undefined || this.state.megaMenuOptions === undefined)
        {
            return null;
        }
        
        
        const schools = this.state.school ? [this.state.school] : [];
        const indexedSchools = buildIndexedSchools(schools);
        
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title={`Site Creation [${this.props.bulkSiteFormId}]`} />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <BulkSiteCreator
                    tenantId={this.props.tenantId}
                    schoolCode={this.props.schoolCode}
                    megaMenuOptions={this.state.megaMenuOptions}
                    bulkCreateSiteForm={this.state.bulkSiteForm}
                    disabled={this.state.bulkSiteForm.locked ? true : false}
                    onFormChanged={(newForm: BulkCreateSiteForm) => {
                        this.setState({bulkSiteForm: newForm});
                    }}
                />

                <div className={"flex-row flex--align-items-center flex--justify-content-center p-2rem"}>
                    {this.buildSaveChangesButton()}
                    {this.buildApproveButton()}
                </div>

                {this.state.workloadInstances.length ? <GroundFloorDurableFunctionInstanceList title="Workloads for sites" instances={this.state.workloadInstances} indexedSchools={indexedSchools} enableRowLinks={true} openRowLinksInNewTab={true} /> : null}

            </Fragment>
        );
    }
}

export default connect((state: IRootState,ownProps: {history: H.History,match: any}): AdminBulkSiteCreationPageProps => {
    
    const tenantId = ownProps.match.params.tenantId;
    const schoolCode = ownProps.match.params.schoolCode;
    const bulkSiteFormId = ownProps.match.params.bulkSiteFormId;

    return {
        tenantId,
        schoolCode,
        bulkSiteFormId,
        history: ownProps.history,
        apiService: state.auth.apiService,
    }
})(AdminBulkSiteCreationPage);